import styled from 'styled-components'

export const Summary = styled.div`
  display: flex;
  gap: 32px;
`

export const SummaryItem = styled.div`
  flex: 1;
  display: flex;
  gap: 8px;
`

export const SummaryLabel = styled.span<{ emphasis?: boolean }>`
  font-family: 'Inter', sans-serif;
  white-space: nowrap;
  ${(props) => (props.emphasis ? 'color: #000; font-weight: 600;' : 'color: #696969;')}
`

export const SummaryValue = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
  flex: 1;
`
